import { render, staticRenderFns } from "./CourseCertificate.vue?vue&type=template&id=4d2fffe9&scoped=true&"
import script from "./CourseCertificate.vue?vue&type=script&lang=js&"
export * from "./CourseCertificate.vue?vue&type=script&lang=js&"
import style0 from "./CourseCertificate.vue?vue&type=style&index=0&id=4d2fffe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fffe9",
  null
  
)

export default component.exports